import React, { useMemo } from 'react';
import type { SafetyReportArtifactDetailResponse } from '../../services/reportsApi';
import InvestigationAlignmentCard from './InvestigationAlignmentCard';
import ClaimsRoiAlignmentCard from './ClaimsRoiAlignmentCard';
import SafetyControlReviewCard from './SafetyControlReviewCard';
import { resolveInvestigationAlignmentFromArtifactDetail } from '../../domain/reportContext/investigationAlignment';
import { resolveClaimsRoiFromArtifactDetail } from '../../domain/reportContext/claimsRoiAlignment';
import { resolveSafetyControlReviewFromArtifactDetail } from '../../domain/reportContext/safetyControlReview';

type Props = {
  artifactData: SafetyReportArtifactDetailResponse | null | undefined;
};

const ArtifactReportAlignmentCards: React.FC<Props> = ({ artifactData }) => {
  const investigationAlignment = useMemo(
    () => resolveInvestigationAlignmentFromArtifactDetail(artifactData),
    [artifactData],
  );
  const claimsRoiAlignment = useMemo(
    () => resolveClaimsRoiFromArtifactDetail(artifactData),
    [artifactData],
  );
  const safetyControlReview = useMemo(
    () => resolveSafetyControlReviewFromArtifactDetail(artifactData),
    [artifactData],
  );

  return (
    <>
      <InvestigationAlignmentCard
        alignment={investigationAlignment}
        title="Investigation alignment"
        testId="artifact-investigation-alignment"
      />
      <ClaimsRoiAlignmentCard
        alignment={claimsRoiAlignment}
        title="Claims / ROI alignment"
        testId="artifact-claims-roi-alignment"
      />
      <SafetyControlReviewCard
        alignment={safetyControlReview}
        title="Safety control review"
        testId="artifact-safety-control-review"
      />
    </>
  );
};

export default ArtifactReportAlignmentCards;
